import React from "react";
import "./CardSection.css";

const Fivebox = () => {
  const items = [
  {
    title: "English Teachers",
    points: [
      "We are continuously on the look out for efficient English teachers.",
      "Please drop your CV to us."
    ]
  },
  {
    title: "Coordinators",
    points: [
      "We are hiring eligible candidates to coordinate among the students, teachers and the management of NewZeal.",
      "Please drop your CV mentioning your area of interest."
    ]
  },
  {
    title: "Sales & Marketing Executives",
    points: [
      "If you are an expert in sales & marketing, both B2B and B2C channels, drop your CV.",
      "We will talk to you very soon."
    ]
  }
];


  return (
    <div className="nz-fivebox-section">
      <h2 className="nz-section-title">
       Our Current Openings
      </h2>
      <div className="nz-fivebox-container">
        {items.map((item, index) => (
          <div key={index} className="nz-fivebox-card fade-in">
            <h3>{item.title}</h3>
            <ul>
              {item.points.map((point, i) => (
                <li key={i}>{point}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div>
      </div>
    </div>
  );
};

export default Fivebox;
